// extracted by mini-css-extract-plugin
module.exports = {"title":"cookie-consent-Accordion-title-bf41d089","body":"cookie-consent-Accordion-body-e005d625","visible":"cookie-consent-Accordion-visible-a3af2c0c"};